<!-- @format -->

<ng-container *transloco="let t">
  <h3>{{ t(titleTranslationKey) }}</h3>
  @if (cooperationNetworkStatus?.direction === "INBOUND") {
    <ng-template [ngTemplateOutlet]="inbound"></ng-template>
  } @else {
    <ng-template [ngTemplateOutlet]="outbound"></ng-template>
  }
  <ng-template #inbound>
    <sis-description-list>
      <ng-template #listItem>
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_RIPA.INBOUND_ORGANISATION") }}</dt>
        @if (cooperationNetworkStatus?.universityOrgId | organisation | async; as university) {
          <dd>
            {{ university.name | localizedString }}
          </dd>
        } @else {
          <ng-template [ngTemplateOutlet]="emptyField"></ng-template>
        }
      </ng-template>
      <ng-template #listItem>
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_RIPA.INBOUND_ORGANISATION_TKCODE") }}</dt>
        <dd>{{ cooperationNetworkStatus?.organisationTkCode ?? "-" }}</dd>
      </ng-template>
      <ng-template #listItem>
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_RIPA.COOPERATION_NETWORK") }}</dt>
        @if (cooperationNetworkStatus?.cooperationNetworkId | cooperationNetwork | async; as cooperationNetwork) {
          <dd>
            {{ (cooperationNetwork.name | localizedString) + ", " + cooperationNetwork.abbreviation }}
          </dd>
        } @else {
          <ng-template [ngTemplateOutlet]="emptyField"></ng-template>
        }
      </ng-template>
    </sis-description-list>
  </ng-template>
  <ng-template #outbound>
    <sis-description-list>
      <ng-template #listItem>
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_RIPA.OUTBOUND_ORGANISATION") }}</dt>
        @if (cooperationNetworkStatus?.universityOrgId | organisation | async; as university) {
          <dd>
            {{ university.name | localizedString }}
          </dd>
        } @else {
          <ng-template [ngTemplateOutlet]="emptyField"></ng-template>
        }
      </ng-template>
      <ng-template #listItem>
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_RIPA.OUTBOUND_ORGANISATION_TKCODE") }}</dt>
        <dd>{{ cooperationNetworkStatus?.organisationTkCode ?? "-" }}</dd>
      </ng-template>
      <ng-template #listItem>
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_RIPA.OUTBOUND_STUDY_RIGHT") }}</dt>
        <dd>{{ cooperationNetworkStatus?.homeStudyRightId ?? "-" }}</dd>
      </ng-template>
      <ng-template #listItem>
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_RIPA.COOPERATION_NETWORK") }}</dt>
        @if (cooperationNetworkStatus?.cooperationNetworkId | cooperationNetwork | async; as cooperationNetwork) {
          <dd>
            {{ (cooperationNetwork.name | localizedString) + ", " + cooperationNetwork.abbreviation }}
          </dd>
        } @else {
          <ng-template [ngTemplateOutlet]="emptyField"></ng-template>
        }
      </ng-template>
      <ng-template #listItem>
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_RIPA.OUTBOUND_STATUS_TITLE") }}</dt>
        <dd>
          {{ t(this.outboundStatusTranslationKey) }}
          @if (cooperationNetworkStatus?.outboundStatus === "NOT_VALID" && cooperationNetworkStatus?.outboundStatusMessage) {
            <sis-technical-message-view
              [title]="t('ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_RIPA.OPEN_ERROR_MESSAGE')"
              [message]="cooperationNetworkStatus.outboundStatusMessage">
            </sis-technical-message-view>
          }
        </dd>
      </ng-template>
    </sis-description-list>
  </ng-template>
  <ng-template #emptyField>
    <dd>-</dd>
  </ng-template>
</ng-container>
